<template>
    <section>
        <div id="ModalShowSignatures" class="modal fade in" role="dialog">
            <div class="modal-dialog modal-el">
                <div class="modal-content">
                    <div class="modal-header">
                        <p class="modal-title"><i class="fa fa-pencil"></i> Assinaturas arquivo:
                            <strong>{{file.arquivo_nome}}</strong></p>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <table class="table table-sm table-condensed">
                                    <thead>
                                        <tr>
                                            <th v-if="file.habilitar_ordem">Ordem</th>
                                            <th>Nome</th>
                                            <th>E-mail</th>
                                            <th>Tipo de Assinatura</th>
                                            <th>Solicitado em</th>
                                            <th>Assinado em</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(assinatura, i) in file.assinaturas" :key="i">
                                            <td v-if="file.habilitar_ordem">{{assinatura.ordem}}</td>
                                            <td><i v-if="assinatura.assinado" class="fa fa-check-circle text-green"></i>
                                                <i v-else class="fa fa-times-circle text-red"></i>
                                                {{assinatura.assinatura_nome}}</td>
                                            <td>{{assinatura.assinatura_email}}</td>
                                            <td>{{getTipoAssinatura(assinatura.assinatura_tipo, assinatura.assinado)}}
                                            </td>
                                            <td>{{formatDate(assinatura.created_at)}}</td>
                                            <td>{{formatDate(assinatura.assinado_em)}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <button type="button" class="float-left btn btn-default" data-dismiss="modal"><i
                                class="fa fa-times"></i> {{$t('words.close')}}</button>

                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        data() {
            return {
                file: {},
            }
        },

    }
</script>